<template>
    <section class="wl-section wl-care-process" id="section_services">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 text-center mb-5">
                    <h2 class="text-white">{{ $t("links.services") }}</h2>
                    <hr class="border-light" style="opacity: 0.2;" />
                </div>
                <div class="row g-4">
                    <div
                        v-for="(service, index) in services"
                        :key="index"
                        class="col-lg-3 col-md-6 col-12"
                    >
                        <template v-if="service.nameParams !== 'noLink'">
                            <router-link :to="service.routeTo || { name: 'Service', params: { service: service.nameParams } }" class="text-decoration-none">
                                <div class="wl-care-process__card h-100">
                                    <div class="wl-care-process__img-wrapper">
                                        <img
                                            :src="`/images/services/${service.img}`"
                                            class="wl-care-process__img"
                                            alt=""
                                        />
                                    </div>
                                    <div class="wl-care-process__content text-center d-flex flex-column justify-content-center" style="min-height: 100px;">
                                        <h5 class="wl-care-process__step-title mb-0" style="line-height: 1.4;">
                                            {{ $i18n.locale == "pt_BR" ? service.labelPtBR : ($i18n.locale == "es" ? service.labelEs : service.labelEn) }}
                                        </h5>
                                    </div>
                                </div>
                            </router-link>
                        </template>
                        <template v-else>
                            <a :href="service.linkExternal" class="text-decoration-none">
                                <div class="wl-care-process__card h-100">
                                    <div class="wl-care-process__img-wrapper">
                                        <img
                                            :src="`/images/services/${service.img}`"
                                            class="wl-care-process__img"
                                            alt=""
                                        />
                                    </div>
                                    <div class="wl-care-process__content text-center d-flex flex-column justify-content-center" style="min-height: 100px;">
                                        <h5 class="wl-care-process__step-title mb-0" style="line-height: 1.4;">
                                            {{ $i18n.locale == "pt_BR" ? service.labelPtBR : ($i18n.locale == "es" ? service.labelEs : service.labelEn) }}
                                        </h5>
                                    </div>
                                </div>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { servicesContent } from "./../pages/ServicesDetails/ServicesContent";

export default {
    name: "ServicesComponent",
    setup() {
        const services = servicesContent;
        return {
            services,
        };
    },
};
</script>
<style scoped>
/* Scoped styles replicating WLCareProcess specifically for the grids to ensure they render perfectly anywhere */
.wl-care-process {
  background: var(--wl-grad-dark);
}

.wl-care-process__card {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.wl-care-process__card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.3);
}

.wl-care-process__img-wrapper {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.wl-care-process__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.wl-care-process__card:hover .wl-care-process__img {
  transform: scale(1.05);
}

.wl-care-process__content {
  padding: 16px;
}

.wl-care-process__step-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0;
}
</style>
